/**
 * Register plugins for Location
 * @module
 */

module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/location'));
  PluginManager.registerAudienceMatcher('location', require('./matchers/location'));
};
